


























































import { KpiEnum } from '../../enums';

import { UiTooltip } from '../keen-ui';

export default {
  name: 'kpi-expander',
  components: {
    UiTooltip
  },
  props: {
    id: {
      type: String,
      required: true
    },
    core: {
      type: Object, // { label: string, values:[ currentPeriod: number, comparePeriod: number ]}
      required: true
    },
    asides: {
      type: Array, // [{ label: string, values:[ currentPeriod: number, comparePeriod: number ], orientation: string, icon?: string}, ...]
      required: true
    },
    expanded: Boolean
  },
  methods: {
    hasComparedValue: function (periodsValues: number[]): boolean {
      return !!periodsValues && !!periodsValues[1];
    },
    getPeriodsDifference: function (periodsValues: number[]): number {
      const mainPeriodValue = periodsValues[0];
      const comparePeriodValue = periodsValues[1];
      const increaseValue = mainPeriodValue - comparePeriodValue;
      return Math.round((increaseValue / (comparePeriodValue || 1)) * 100);
    },
    getCompareArrowIconClasses: function (periodsValues: number[]): string[] {
      const periodsDifference = this.getPeriodsDifference(periodsValues);
      const classes = [this.getValueColorClass(periodsDifference)];
      if (periodsDifference > 0) {
        classes.push('epb-kpi-expander__icon--arrow-up');
      }
      return classes;
    },
    getPeriodValueText: function (periodValue: number, roundLongNumber?: boolean): string {
      return this.$epb.utils.formatNumber(periodValue, { maximumFractionDigits: 2 }, roundLongNumber);
    },
    getValueColorClass: function (value: number): string {
      const positiveClass = 'epb-kpi-expander__icon--positive';
      const negativeClass = 'epb-kpi-expander__icon--negative';
      if (this.id !== KpiEnum.NO_RESULTS) {
        return value > 0 ? positiveClass : negativeClass;
      } else {
        return value < 0 ? positiveClass : negativeClass;
      }
    }
  }
};
